export function createContentImage(block, parent) {
    const blockName = block.data_block_name;

    const wrapper = document.createElement('div');
    wrapper.className = 'content-image-block';
    wrapper.setAttribute('data-block-name', blockName);
    wrapper.setAttribute('data-block-id', block.id || '');
    wrapper.setAttribute('data-order', String(block.order ?? 0));
    if (block.page_id) {
        wrapper.setAttribute('data-page-id', String(block.page_id));
    }

    const pageTitle = block.page_title || (block.extra_fields && block.extra_fields.page_title);
    if (pageTitle) {
        wrapper.setAttribute('data-page-title', pageTitle);
    }

    wrapper.innerHTML = `
        <div class="content-row">
            <div class="content-row__label">
                <p class="content-label" data-content="${blockName}-label" data-global="false"></p>
            </div>
            <div class="content-row__body">
                <img class="article-inner-image"
                     data-content="${blockName}-image"
                     data-type="image"
                     data-global="false"
                     alt="">
            </div>
        </div>
    `;

    parent.appendChild(wrapper);
    return wrapper;
}

export const contentImageProps = {
    name: 'content-image',
    title: 'Зображення',
    description: 'Рядок з міткою ліворуч і зображенням праворуч',
    allowedParents: ['news-content', 'diagnostic-content'],
    requiresPage: true,
    contentFields: [
        { name: 'label', type: 'text', label: 'Мітка (ліворуч)' },
        { name: 'image', type: 'image', label: 'Зображення (праворуч)' }
    ],
    renderPreview: (data) => {
        return `
            <div class="block-preview content-image-preview" style="display:flex;gap:10px;align-items:center;">
                <span style="flex:0 0 50%;font-size:11px;opacity:0.5;">${data.label || 'Мітка...'}</span>
                <img src="${data.image || ''}" alt="" style="flex:1;max-width:100%;border-radius:6px;" />
            </div>
        `;
    }
};
